// extracted by css-extract-rspack-plugin
export default {"manualLinkSetupLayoutRoot":"S7WiaC"};